/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { all, takeEvery } from "redux-saga/effects";

import {
  GET_COMPANY,
  GET_COUNTS_REQUEST,
  GET_HP_REQUEST,
  GET_PROFILE,
  LOGOUT_REQUEST,
  SIGN_IN_REQUEST,
} from "../actions/auth";

import {
  getCompany,
  getCounts,
  getHp,
  getProfile,
  logout,
  signIn,
} from "./auth";

function* rootSaga() {
  yield all([
    takeEvery(SIGN_IN_REQUEST, signIn),
    takeEvery(LOGOUT_REQUEST, logout),
    takeEvery(GET_COUNTS_REQUEST, getCounts),
    takeEvery(GET_HP_REQUEST, getHp),
    takeEvery(GET_PROFILE, getProfile),
    takeEvery(GET_COMPANY, getCompany),
  ]);
}

export default rootSaga;
